module.exports = __webpack_public_path__ + "img/1.a8bd99f9.jpg";